import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
     onUpdateColumn,
     setOrder,
     setSelectedRow,
     setPage,
     setPageSize
} from '../../../store/fuerzaventas/cargamasivarutas/actions';
import { sort_by} from '../../../helpers/commons'

import { SET_MASK} from '../../../store/fuerzaventas/cargamasivarutas/types';

import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
    }, 
    tableWrap: {
        flex: '1 1 auto',
    }
}));

const CargaMasivaSucursalesResponse = () => {

    const classes = useStyles();
    const columns = useSelector(state => state.cargamasivarutas.table2.columns);
    const loadingStore = useSelector(state => state.cargamasivarutas.store.loading);
    const order = useSelector(state => state.cargamasivarutas.table2.order);
    const orderBy = useSelector(state => state.cargamasivarutas.table2.orderBy);
    const store = useSelector(state => state.cargamasivarutas.store);
    const dispatch = useDispatch();


    const handleRequestSort = (property) => {
        dispatch({ type: SET_MASK, loading: true });
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
        let homes = store.data5;
        homes.sort(sort_by(property, isAsc, homes[0][property]));
        dispatch({ type: SET_MASK, loading: false});
    };

    function handleChangePage(newPage) {
        dispatch(setPage(newPage));
    }
    
    function handleChangeRowsPerPage(event) {
        dispatch(setPageSize(event.target.value));
        dispatch(setPage(0));
    }
    
    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column))
    };

    return (
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
            <div className={classes.tableWrap}>
                <Table
                    columns={columns}
                    count={store.total}
                    loading={loadingStore}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    onRowClick={items => dispatch(setSelectedRow(items))}
                    onSort={datakey => handleRequestSort(datakey)}
                     onUpdateColumn={handleResizeColumn}
                    page={store.start/store.pageSize}
                    paginate
                    rowCount={store.data5.length}
                    rowGetter={index =>  store.data5[index] }
                    rowsPerPage={store.pageSize}
                    selected={store.selected5}
                    sortBy={orderBy}
                    sortDirection={order}
                    enableColumnResize={true}
                    scrollTop = {true}
                />
            </div>
        </FieldSet>
    )
};

export default CargaMasivaSucursalesResponse;
